import React from "react"

export default function Settings(params) {
    return (
        <div className="user-management-container">
            Settings
        </div>
    )
}